import { Button, Modal } from '@catering/ui';
import type { JSX } from 'react';

import { mapDietaryWarning } from '../../../calendar/calendar-api-errors';

export interface DietaryWarningModalProps {
  warnings: string[];
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * `menu-calendar/spec.md` → "Confirmación explícita de advertencia dietaria
 * al publicar". The `PATCH /calendar/:id/publish` call already happened by
 * the time this modal opens (the API never blocks on `dietaryWarnings`,
 * `menu-calendar/spec.md` → "Publicación explícita"): "Publicar de todas
 * formas" only confirms the local state, and "Cancelar" reverts it without
 * a second network call — the parent owns both, this component only
 * renders the two choices.
 */
export function DietaryWarningModal({
  warnings,
  onConfirm,
  onCancel,
}: DietaryWarningModalProps): JSX.Element {
  return (
    <Modal open onClose={onCancel} title="Advertencia dietaria" className="max-w-md">
      <div className="flex flex-col gap-4">
        <p className="text-sm text-slate-600">
          Esta fecha todavía no tiene cobertura dietaria completa:
        </p>

        <ul className="flex flex-col gap-1 text-sm text-amber-800">
          {warnings.map((warning) => (
            <li key={warning} className="flex items-center gap-2">
              <span aria-hidden="true" className="size-1.5 rounded-full bg-amber-500" />
              {mapDietaryWarning(warning)}
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-3">
          <Button type="button" onClick={onConfirm}>
            Publicar de todas formas
          </Button>
          <Button type="button" variant="secondary" onClick={onCancel}>
            Cancelar
          </Button>
        </div>
      </div>
    </Modal>
  );
}
